import { useQuery } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { CARE_SOURCE } from '../constants';
import { CareMonthOverview, CareSuccess } from '../types';
import { CARE_MONTH_KEY, careBillingUrl } from './constants';
import useCareScope from './useCareScope';

const useCareMonth = (month: string) => {
    const req = useRequest();
    const orgId = useCareScope();

    const request = () =>
        req<CareSuccess<CareMonthOverview>>({
            url: `${envVars.API_RTM_HOSTNAME}${careBillingUrl('month/')}`,
            query: { month, source: CARE_SOURCE }
        }).then((response) => response.data);

    return useQuery({ queryFn: request, queryKey: [CARE_MONTH_KEY, orgId, month] });
};

export default useCareMonth;
